import { api } from '@api'
import { useQuery } from '@tanstack/react-query'
import { CalendarEvent } from './usePaginateCalendarEvents'

interface GetCalendarEventByIdResponse {
  calendarEvent: CalendarEvent
}

const fetchCalendarEventById = async (id: string): Promise<CalendarEvent> => {
  const { data } = await api.get<GetCalendarEventByIdResponse>(`/calendar-events/${id}`)
  return data.calendarEvent
}

export const useGetCalendarEventById = (id: string) => {
  return useQuery<CalendarEvent>({
    queryKey: ['calendar-event', id],
    queryFn: () => fetchCalendarEventById(id),
    enabled: !!id,
  })
}

